@if (ngFormGroup) {
  <form (ngSubmit)="onSave()" matForm [formGroup]="ngFormGroup" style="height: auto;">
    @if (NgFormGroup != null) {
      <div class="form configuration-popup">
        <div class="config-section">
          <h2>Common Options</h2>
          <div>
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
              <mat-label>Display Name</mat-label>
              <input matInput placeholder="Name" formControlName="displayName" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
              <mat-label>Internal Name</mat-label>
              <input matInput formControlName="name" (ngModelChange)="handleModelChange('name')" />
            </mat-form-field>
            <small class="property-error-message property-red">
              {{this.FieldNameErrorMsg}}
            </small>
          </div>
          <div>
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
              <mat-label>Tool Tip</mat-label>
              <input matInput formControlName="toolTip" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
              <mat-label>Placeholder</mat-label>
              <input matInput formControlName="placeholderText" />
            </mat-form-field>
          </div>
          <div>
            <mat-label>Instructions</mat-label>
            <kendo-editor name="kendo-editor" formControlName="instructionsText"></kendo-editor>
          </div>
          <div>
            <div class="pad-top-10">
              <div class="pad-right-25" style="float:left;">
                Footnote<br />
                <mat-button-toggle-group formControlName="hasFootnote">
                  <mat-button-toggle [value]="true">Show</mat-button-toggle>
                  <mat-button-toggle [value]="false">Hide</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
              <div>
                Required<br />
                <mat-button-toggle-group formControlName="required">
                  <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                  <mat-button-toggle [value]="false">No</mat-button-toggle>
                </mat-button-toggle-group><br />
                <!--Consider Use an info icon to display the tip below-->
                <!--<small>Require that this control contains information</small>-->
              </div>
            </div>
          </div>
        </div>
        <div class="config-section">
          <h2>Field Type Options</h2>
          @if (FieldColumnPairs.length > 0) {
            <div>
              <div class="field-column-pairs">
                <div><strong>Constraint</strong></div>
                <div><strong>Column</strong></div>
                <div></div>
              </div>
              @for (pair of FieldColumnPairs; track pair) {
                <div>
                  <div class="field-column-pairs">
                    <div title="{{pair.constraintName}}">
                      {{pair.constraintName}}
                    </div>
                    <div title="{{pair.listConstraintColumnName}}">
                      {{pair.listConstraintColumnName}}
                    </div>
                    <div>
                      <button mat-icon-button
                        style="bottom: 8px;"
                        type="button"
                        (click)="deleteFCpair(pair)"
                        (keyup.enter)="deleteFCpair(pair)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              }
              <br />
            </div>
          }
          <div>
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
              <mat-label>Select a constraint</mat-label>
              @if (this.LoadingConstraints) {
                <mat-spinner [diameter]="25"></mat-spinner>
              }
              <mat-select name="selectConstraint" formControlName="selectedConstraintName" (selectionChange)="onSelectConstraint($event)">
                @for (con of Constraints; track con) {
                  <mat-option
                    title="{{con.name}}"
                    [value]="con.name">
                    {{con.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
              <mat-label>Select constraint column</mat-label>
              @if (this.LoadingColumns) {
                <mat-spinner [diameter]="25"></mat-spinner>
              }
              <mat-select name="selectColumn" formControlName="selectedConstraintColumnName" (selectionChange)="onSelectColumn($event)">
                @for (col of Columns; track col) {
                  <mat-option
                    title="{{col.name}}"
                    [value]="col.name">
                    {{col.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <!--
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="narrow-form-field">
              <mat-label>Minimum Selections</mat-label>
              <input matInput formControlName="minimumSelections" type="number" min="0" value="0" />
            </mat-form-field>
            &nbsp;
            -->
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="narrow-form-field">
              <mat-label>Maximum Selections</mat-label>
              <input matInput formControlName="maximumSelections" type="number" min="0" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
              <mat-label>Select Source Field</mat-label>
              <mat-select formControlName="dependsOnParentFormFieldName" (selectionChange)="onSelectSourceField($event)">
                <mat-option>None</mat-option>
                @for (src of AvailableSourceFields; track src) {
                  <mat-option title="{{src.displayName}}" [value]="src.name">
                    @if (src.displayName) {
                      <span>{{src.displayName}}</span>
                    }
                    @if (!src.displayName) {
                      <span>{{src.name}}</span>
                    }
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (SourceFieldIsNotFlexField) {
              <div>
                <!-- See https://community-dc.max.gov/x/CASmn for overview of what this next bit does -->
                <h5>
                  Constraints for Source Field: {{SelectedSourceField.displayName ?? SelectedSourceField.name}}
                </h5>
                @if (SourceFieldConstraints == null || SourceFieldConstraints.length == 0) {
                  <div style="margin-bottom: 20px; color: #EF0000;">
                    <small>The selected source field is not a flex field and so needs to be configured with constraint(s) and column(s) below</small>
                  </div>
                }
                @if (SourceFieldConstraints.length > 0) {
                  <div>
                    <div class="field-column-pairs">
                      <div><strong>Constraint</strong></div><div><strong>Column</strong></div><div></div>
                    </div>
                    @for (pair of SourceFieldConstraints; track pair) {
                      <div>
                        <div class="field-column-pairs">
                                <div title="{{pair.constraintName
                        }}">
                            {{pair.constraintName}}
                          </div>
                          <div title="{{pair.listConstraintColumnName}}">{{pair.listConstraintColumnName}}</div>
                          <div>
                            <button mat-icon-button style="bottom: 8px;" type="button" (click)="deleteFCpair(pair, SelectedSourceField)" (keyup.enter)="deleteFCpair(pair, SelectedSourceField)">
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                    }
                    <br />
                  </div>
                }
                <div>
                  <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Select a constraint</mat-label>
                    @if (this.LoadingConstraints) {
                      <mat-spinner [diameter]="25"></mat-spinner>
                    }
                    <mat-select name="selectConstraint" formControlName="selectedConstraintName" (selectionChange)="onSelectConstraint($event, SelectedSourceField)">
                      @for (con of Constraints; track con) {
                        <mat-option
                          title="{{con.name}}"
                          [value]="con.name">
                          {{con.name}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Select constraint column</mat-label>
                    @if (this.LoadingColumns) {
                      <mat-spinner [diameter]="25"></mat-spinner>
                    }
                    <mat-select name="selectColumn" formControlName="selectedConstraintColumnName" (selectionChange)="onSelectColumn($event, SelectedSourceField)">
                      @for (col of Columns; track col) {
                        <mat-option
                          title="{{col.name}}"
                          [value]="col.name">
                          {{col.name}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            }
          </div>
          <div>
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
              <mat-label>Default Value</mat-label>
              <input matInput formControlName="defaultValue" />
            </mat-form-field>
          </div>
          <!--The following can be used to change the default value to a dropdown-->
          <!--<div>
          <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
            <mat-label>Select Default Value</mat-label>
            <mat-select name="selectDefaultValue">
              <mat-option *ngFor="let opt of AvailableDefaultValues"
                title="{{opt.value}}"
                [value]="opt.value">
                {{opt.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>-->
        <div>
          Autocomplete<br />
          <mat-button-toggle-group formControlName="autoCompleteEnabled">
            <mat-button-toggle [value]="true">Yes</mat-button-toggle>
            <mat-button-toggle [value]="false">No</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      <div class="config-section" style="display: none;">
        <h2>Preview</h2>
      </div>
    </div>
  }
  <div class="bottom-buttons">
    <button mat-raised-button type="submit" color="primary" title="field ID {{this.FormField.id}}"
      [disabled]="this.FieldNameErrorMsg != null">
      Save Template
    </button>
    &nbsp;
    <button mat-raised-button type="button" color="secondary" [mat-dialog-close] (click)="cancelClicked()">Cancel</button>
  </div>
</form>
}
